import { DetailBox } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../../utils/dates';
import { Course } from '../types';
import { TranslationsKeys } from '../../../../locales/translations';

type CourseDetailsBoxProps = {
  course: Course;
};

const CourseDetailsBox = ({ course }: CourseDetailsBoxProps) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);

  if (course) {
    return (
      <DetailBox
        columns={[
          {
            title: t('code'),
            body: course.code || '',
            size: { xs: 12, md: 3 },
          },
          {
            title: t('name'),
            body: course.name || '',
            size: { xs: 12, md: 3 },
          },
          {
            title: t('translation:common.createdAt'),
            body: formatDate(course.createdAt, 'DD-MM-YYYY'),
            size: { xs: 12, md: 3 },
          },
          {
            title: t('translation:common.updatedAt'),
            body: formatDate(course.updatedAt, 'DD-MM-YYYY'),
            size: { xs: 12, md: 3 },
          },
        ]}
      />
    );
  }

  return (
    <DetailBox
      columns={[
        {
          title: t('translation:common.createdAt'),
          body: '',
          size: { xs: 12, md: 6 },
        },
        {
          title: t('translation:common.updatedAt'),
          body: '',
          size: { xs: 12, md: 6 },
        },
      ]}
    />
  );
};

export default CourseDetailsBox;
